import React from "react";
import { connect } from "react-redux";
import { Tab } from "semantic-ui-react";

import {
  emptyInstallationsSection,
  fetchInstallations,
  fetchInstallationsFilters,
} from "@actions";
import CollectionBanking from "@components/SiteInstallations/CollectionBanking";
import CollectionPerformance from "@components/SiteInstallations/CollectionPerformance";
import MachineCounts from "@components/SiteInstallations/MachineCounts";
import SiteInstallations from "@components/SiteInstallations/SiteInstallations";
import VarianceHistory from "@components/SiteInstallations/VarianceHistory";

class SiteInstallationsView extends React.Component {
  state = {
    currentOrganisationId: 0,
  };

  getPanes = () => {
    const panes = [];

    const {
      optionShowInstCollectionTabs,
      optionShowInstVarianceTab,
      optionShowInstCountDetailsTab,
      optionShowInstCollectionBankingTab
    } = this.props.logIn;

    if (optionShowInstCollectionTabs) {
      panes.push({
        menuItem: "Collection - Net Income",
        pane: (
          <Tab.Pane>
            <CollectionPerformance
              operator={this.props.filters.filterSelected.operator}
              siteId={this.props.filters.filterSelected.site.id}
            />
          </Tab.Pane>
        ),
      });
    }

    if (optionShowInstCollectionTabs && optionShowInstCollectionBankingTab) {
      panes.push({
        menuItem: "Collection - Banking",
        pane: (
          <Tab.Pane>
            <CollectionBanking
              operator={this.props.filters.filterSelected.operator}
              siteId={this.props.filters.filterSelected.site.id}
            />
          </Tab.Pane>
        ),
      });
    }

    if (optionShowInstVarianceTab) {
      panes.push({
        menuItem: "Collection - M/c Variance",
        pane: (
          <Tab.Pane>
            <VarianceHistory
              operator={this.props.filters.filterSelected.operator}
              siteId={this.props.filters.filterSelected.site.id}
            />
          </Tab.Pane>
        ),
      });
    }

    if (optionShowInstCountDetailsTab) {
      panes.push({
        menuItem: "Collection - M/c Counts",
        pane: (
          <Tab.Pane>
            <MachineCounts
              operator={this.props.filters.filterSelected.operator}
              siteId={this.props.filters.filterSelected.site.id}
            />
          </Tab.Pane>
        ),
      });
    }

    return panes;
  };

  componentWillUnmount() {
    this.props.emptyInstallationsSection();
  }

  render() {
    const panes = this.getPanes();

    const expanded =
      this.state.expanded ||
      !this.props.filters.filterSelected.operator ||
      !this.props.filters.filterSelected.site.id;

    return (
      <div className="gs-flex-container-vertical h-100">
        <SiteInstallations
          organisationId={this.props.filters.filterSelected.site.id}
          handleExpand={() => this.setState({ expanded: !expanded })}
          expanded={expanded}
        />
        {!expanded && panes.length > 0 && (
          <Tab
            renderActiveOnly={false}
            panes={panes}
            installation={this.state.activeInstallation}
            className="flex-stretch gs-flex-container-vertical mt-1 h-100"
            menu={{ size: "tiny", attached: "top", compact: true }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    filters: state.installationsFilters,
    logIn: state.logIn,
  };
};

export default connect(mapStateToProps, {
  fetchInstallations,
  fetchInstallationsFilters,
  emptyInstallationsSection,
})(SiteInstallationsView);
